import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  exportHrReportStart,
  exportHrReportSuccess,
  exportHrReportFailed,
} from "../redux/exportHrReport";

import { SCREEN } from "helper/roleChecker/Screens";
import { formFilterHrReportSelector } from "../redux/selector";
import { exportHrReportApi } from "core/http/service/timeKeeping";
import { toast } from "react-toastify";
import { EXPORT_TYPE } from "../redux/formFilterHrReport";
import moment from "moment";

function* exportHrReportWork() {
  const form = yield select(formFilterHrReportSelector);
  const { type, fromMonth, fromYear, toMonth, toYear } = form;

  try {
    let fileName = "";
    const fromDate = new Date(fromYear, fromMonth - 1, 1);
    const toDate = new Date(toYear, toMonth - 1, 1);
    const fromDateFormat = moment(fromDate).format("MM/YYYY");
    const toDateFormat = moment(toDate).format("MM/YYYY");

    switch (type) {
      case EXPORT_TYPE.CHECK_IN_OUT:
        fileName = `BAO_CAO_CHAM_CONG_CUA_CBNV_${fromDateFormat}-${toDateFormat}`;
        break;
      case EXPORT_TYPE.LEAVE_REPORT:
        fileName = `BAO_CAO_NGAY_PHEP_${toDateFormat}`;
        break;
      case EXPORT_TYPE.COMPENSATORY_LEAVE_REPORT:
        fileName = `BAO_CAO_NGHI_BU_CUA_CBNV_${toDateFormat}`;
        break;
      case EXPORT_TYPE.LATE_EARLY_REPORT:
        fileName = `BAO_CAO_DI_MUON_VE_SOM_${fromDateFormat}-${toDateFormat}`;
        break;
      case EXPORT_TYPE.TIMEKEEPING_DETAIL:
        fileName = `BAO_CAO_CHI_TIET_CHAM_CONG_${fromDateFormat}-${toDateFormat}`;
        break;
      default:
        fileName = "BAO_CAO_TONG_HOP";
        break;
    }
    const res = yield call(exportHrReportApi, {
      screenCode: SCREEN.IP_021,
      ...form,
    });

    const blob = new Blob([res], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create a URL for the blob
    const url = window.URL.createObjectURL(blob);

    // Create a link element
    const a = document.createElement("a");
    a.href = url;
    a.download = `${fileName}.xlsx`; // Name of the file to download

    // Append link to body and trigger download
    document.body.appendChild(a);
    a.click();

    // Clean up
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    yield put({
      type: exportHrReportSuccess.type,
    });
  } catch (error: any) {
    yield put({
      type: exportHrReportFailed.type,
    });
    toast.error("Đã có lỗi xảy ra");
  }
}

function* watchExportHrReport() {
  yield takeLatest(exportHrReportStart.type, exportHrReportWork);
}

export default function* exportHrReportSaga() {
  yield all([watchExportHrReport()]);
}
